import { NgModule } from '@angular/core';

import { AnalyticsCoreModule } from '../../analytics-core/analytics-core.module';
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';
import { ContentModule } from '../content/content.module';
import { NavigationModule } from '../navigation/navigation.module';
import { LayoutComponent } from './components/layout.component';

@NgModule({
	bootstrap: [LayoutComponent],
	declarations: [LayoutComponent],
	exports: [LayoutComponent],
	imports: [AnalyticsCoreModule, NavigationModule, BreadcrumbModule, ContentModule]
})
export class LayoutModule {}
